import RadioSliderField from './RadioSliderField.component';

export default RadioSliderField;